// KB submit-issue form: Describe your issue character limit.
export const SUBMIT_ISSUE_QUERY_MAX_LENGTH = 2000;
